import React from 'react'
import useMount from 'react-use/lib/useMount'
import { Form, Field } from 'redux-form'

import Button from 'components/Button'
import { Container } from 'components/Layout'
import LoadingLinear from 'components/Loading/LoadingLinear'
import SelectPretty from 'components/Input/SelectPretty'
import { Input } from 'components/Input/Input'

import cn from 'classnames'
import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'
import s from './NumbersDisconnectModal.scss'

const duration = {
  number: '10 business days',
  phoneLine: '7 business days',
  internet: '21 business days',
  phoneSystem: '21 business days',
}

const reasons = [
  "I'm looking to change my plan",
  "I'm having too many technical issues",
  "The service didn't work as expected",
  "I'm not using the service often enough",
  "It's too expensive",
  'Service and features are too complicated for me',
  "I needed the service for a project I've since completed",
  'My business is shutting down',
  'I have another service with Pickle',
  'You have inadequate support',
  'Other reason',
]

const reasonOptions = reasons.map(reason => ({ name: reason, value: reason }))

export default props => {
  useMount(() => {
    const { getNumber, service, getDisconnectionFee, serviceId } = props
    if (!service) {
      getNumber(serviceId)
    }

    getDisconnectionFee(serviceId)
  })

  const {
    service,
    serviceId,
    disconnectService,
    fee,
    loading,
    reason,
    customReason,
    submitting,
    modalConfirm,
    modalCancel,
    type = 'number',
  } = props

  const submit = () => disconnectService(serviceId, customReason || reason).then(modalConfirm)

  const askForReason = reasons[reasons.length - 1] === reason

  return (
    <Container paddingTop paddingBottom className="sm">
      {loading ? (
        <LoadingLinear />
      ) : (
        <>
          <div className={cn(sText.descrip2, sText.center)}>
            Disconnect Service {service.number}
            {service.customerReference ? ` (${service.customerReference})` : ''}
          </div>

          <div className={cn(sText.descrip3, sText.center, s.info)}>
            This will cost ${fee} and take up to {duration[type]} to process.
          </div>

          <Form>
            <Field
              name="reason"
              component={SelectPretty}
              options={reasonOptions}
              label="Why do you want to cancel?"
            />

            {askForReason && (
              <Field name="customReason" component={Input} label="Please specify your reason" />
            )}
          </Form>

          <div
            className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
            style={{ marginTop: '40px' }}
          >
            <Button
              onClick={submit}
              color="warn"
              loading={submitting}
              disabled={submitting || !reason || (askForReason && !customReason)}
            >
              Confirm
            </Button>
            <br />
            <br />
            <Button plain onClick={modalCancel}>
              Cancel
            </Button>
          </div>
        </>
      )}
    </Container>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersDisconnectModal/NumbersDisconnectModal.jsx